uniform vec2 uResolution;
uniform float uSize;
uniform sampler2D uParticlesTexture;
uniform float uColor;
uniform vec3 uPosition;
uniform float uWidth;  // New uniform for screen width adaptation

attribute vec2 aParticlesUv;
attribute float aSize;

varying vec3 vColor;

void main()
{
    vec4 particle = texture(uParticlesTexture, aParticlesUv);

    // Modify the particle's position by the uPosition and uWidth
    vec4 modelPosition = modelMatrix * vec4(particle.xyz * uWidth + uPosition, 1.0);

    // Final position
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    gl_Position = projectedPosition;

    // Point size
    float sizeIn = smoothstep(0.0, 0.1, particle.a);
    float sizeOut = 1.0 - smoothstep(0.0, 0.1, particle.a);
    float size = min(sizeIn, sizeOut);

    gl_PointSize = uSize * uResolution.y;
    gl_PointSize *= (1.0 / -viewPosition.z);

    // Varyings
    vColor = vec3(1.0 - uColor);
}
